import React, { useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import MyPoolsCard from './MyPoolsCard/MyPoolsCard';
import StaticPoolHeaderBar from '../PoolHeaderBar/StaticPoolHeaderBar';
import { useNFLCurrentWeek } from '../../hooks/nfl';
import { useCFBCurrentWeek } from '../../hooks/cfb';
import { useMyPoolsPageContext } from './context/MyPoolsPageContext';
import useNavigateToTop from '../../hooks/general/useNavigateToTop';
import './MyPoolsPage.scss';
import MyInactivePools from './MyPoolsPages/MyInactivePools';
import MyActivePools from './MyPoolsPages/MyActivePools';

const MyPoolsPageContainer = () => {
    const { myUserId, userData, gamesData } = useMyPoolsPageContext();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigateToTop = useNavigateToTop();

    const { mutate: fetchNFLCurrentWeek, data: nflCurrentWeek, isLoading: nflLoading, isError: nflError, error: nflErrorData } = useNFLCurrentWeek();
    const { mutate: fetchCFBCurrentWeek, data: cfbCurrentWeek, isLoading: cfbLoading, isError: cfbError, error: cfbErrorData } = useCFBCurrentWeek();

    const [myPoolsState, setMyPoolsState] = useState('active');

    const handleTabChange = (tab) => {
        setMyPoolsState(tab);
    };

    const userInactiveGames = userData?.Games?.filter(game => 
        game.pool?.dontShowInMyPools || game.settings?.dontShowInMyPools
    ).map(game => game.gameID || game.masterPoolId);
    
    //console.log("User Inactive Games:", userInactiveGames);
    
    const filteredGameData = gamesData?.filter(game => {
        if (myPoolsState === 'active') {
            // For active mode: Only show games not hidden by the webmaster
            return !game.dontShowInMyPools;
        } else if (myPoolsState === 'inactive') {
            // For inactive mode: Include games hidden by the webmaster or by the user
            return game.dontShowInMyPools || userInactiveGames?.includes(game.gameID);
        }
        return false; // Fallback (unlikely needed)
    });
    
    //console.log("Filtered Game Data:", filteredGameData);
    
  

  

    const userGames = userData?.Games?.filter(game =>
        myPoolsState === 'active' ? 
            !(game.pool?.dontShowInMyPools || game.settings?.dontShowInMyPools) 
            : true
    );
    //console.log("User Games:", userGames);

    

    const hasData = myUserId !== null;

    return (
        <>
            <StaticPoolHeaderBar navigationText="Home" headerText="My Pools" linkForNavigation="/" />
    
            <Box
                sx={{
                    padding: '48px 32px 64px 32px',
                }}
            >
                <Box
                    sx={{
                        maxWidth: '1312px',
                        margin: '0 auto',
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: 'center',
                        justifyContent: isMobile ? 'center' : 'space-between',
                    }}
                    >
                    <Typography
                        sx={{
                            fontSize: isMobile ? '24px' : '42px',
                            fontWeight: 800,
                            textAlign: isMobile ? 'center' : 'left',
                        }}
                    >
                        {userData.user_name}
                    </Typography>

                    {!isMobile && (
                        <Box
                            component="img"
                            src="https://poolpartyfilestorage.blob.core.windows.net/media/PoolPartyGamingGreyStacked.png"
                            alt="Pool Party Logo"
                            sx={{
                                height: '135px',
                                maxHeight: '135px',
                            }}
                        />
                    )}
                </Box>

                <Box
                    sx={{
                        position: 'relative',
                        paddingTop: isMobile ? '24px' : '42px',
                        paddingBottom: isMobile ? '24px' : '42px',
                        maxWidth: '1312px',
                        margin: '0 auto',
                    }}
                    >
                    <Box
                        sx={{
                        position: 'absolute',
                        top: '50%',
                        left: 0,
                        width: '100%',
                        height: '1px',
                        backgroundColor: '#CCCCCC',
                        transform: 'translateY(-50%)',
                        }}
                    />
                    </Box>



                <Box 
                    className="super-pickem-leaderboard-button-container"
                    sx={{
                        marginBottom: '32px',
                    }}    
                >
                    <Button
                        className={`super-pickem-leaderboard-button ${myPoolsState === 'active' ? 'active' : ''}`}
                        onClick={() => handleTabChange('active')}
                    >
                        Active
                    </Button>

                    <Button
                        className={`super-pickem-leaderboard-button ${myPoolsState === 'completed' ? 'active' : ''}`}
                        onClick={() => handleTabChange('completed')}
                    >
                        Completed
                    </Button>

                    <Button
                        className={`super-pickem-leaderboard-button ${myPoolsState === 'inactive' ? 'active' : ''}`}
                        onClick={() => handleTabChange('inactive')}
                    >
                        Archive
                    </Button>
                </Box>

                {myPoolsState === 'active' && (
                    <MyActivePools active={true}/>
                )}

                {myPoolsState === 'completed' && (
                    <MyActivePools/>
                )}

                {myPoolsState === 'inactive' && (
                    <MyInactivePools />
                )}
                
            
                <Box
                    sx={{
                        marginTop: '32px',
                    }}
                ></Box>  
            </Box>
        </>
  );
};

export default MyPoolsPageContainer;
